import { render, staticRenderFns } from "./balance-detail.vue?vue&type=template&id=6d13acf7&scoped=true&"
import script from "./balance-detail.vue?vue&type=script&lang=js&"
export * from "./balance-detail.vue?vue&type=script&lang=js&"
import style0 from "./balance-detail.vue?vue&type=style&index=0&id=6d13acf7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d13acf7",
  null
  
)

export default component.exports